import { AxiosResponse } from "axios";
import ApiClient from "../../ApiClient";

const viewerApi = new ApiClient("/Viewer");

export const token = (): Promise<string> =>
    viewerApi.get("/Token").then((response: AxiosResponse<string>) => {
        return Promise.resolve(response.data);
    });
